import {
    Button,
    Form,
    Modal,
    Input,
    Upload,
    Dropdown,
    Skeleton,
    message,
} from "antd";
import React, { useEffect, useState } from "react";
import {
    usePostOnInstagram,
    useRenderCreation,
    useWriteCaption,
} from "../_actions/social";
import log from "cslog";
import { atom, useAtom } from "jotai";
import { useItemsFine } from "../_actions/app/items";
import {
    InstagramOutlined,
    FacebookOutlined,
    LinkedinOutlined,
    DownOutlined,
    PlusOutlined,
    LinkedinFilled,
    InstagramFilled,
    FacebookFilled,
} from "@ant-design/icons";
import { history } from "../_helpers/history";

const postAtom = atom({
    caption: "",
    image_url: null,
});
export const socialAccountAtom = atom(null);

function SocialPostButton({
    template_id,
    creation_id,
    org_id,
    init_account_id,
    prefill = {},
    to, // <-- new prop, expected values like 'instagram' or 'linkedin'
}) {
    const [messageApi, contextHolder] = message.useMessage();
    const {
        isSuccess: successSK,
        isLoading: loadingSK,
        data: dataSK,
        refetch: refetchSK,
    } = useItemsFine(
        "qdb_social_keys",
        `filter[organization][_eq]=${org_id}`,
        true
    );
    const [account, setAccount] = useAtom(socialAccountAtom);

    // Normalize requested platform from `to` prop
    const platformKey = to
        ? to.toString().toLowerCase() === "linkedin"
            ? "Linkedin"
            : to.toString().toLowerCase() === "instagram"
            ? "Instagram"
            : to
        : null;

    // filter accounts to the requested platform if provided
    const filteredAccounts = successSK
        ? dataSK.filter((i) =>
              platformKey
                  ? i.platform?.toLowerCase() === platformKey.toLowerCase()
                  : true
          )
        : [];

    const [open, setOpen] = useState(false);
    const [post, setPost] = useAtom(postAtom);

    const mutationRender = useRenderCreation((res) => {
        log.d(res, "SPB RES");
        if (res?.success) {
            // setImgUrl(res?.data?.image_url);
            setPost({ ...post, image_url: res?.data?.image_url });
        }
    });
    const mutationCaption = useWriteCaption((res) => {
        log.d(res, "SPB RES");
        if (res?.success) {
            // setImgUrl(res?.data?.image_url);
            setPost({ ...post, caption: res?.data?.content });
        }
    });
    const mutationPostInstagram = usePostOnInstagram((res) => {
        messageApi.success("Successfully posted on instagram");
        setOpen(false);
    });

    useEffect(() => {
        if (successSK) {
            if (dataSK.length > 0) {
                // choose initial account from filtered list (if any)
                const init_account = filteredAccounts.find(
                    (i) => i.account_id === init_account_id
                );
                if (init_account) {
                    setAccount(init_account);
                } else {
                    setAccount(
                        filteredAccounts?.[1] ||
                            filteredAccounts[0] ||
                            dataSK[0]
                    );
                }
            }
        }
    }, [successSK, dataSK, init_account_id, to]);

    useEffect(() => {
        log.d([post], "SPB useEffect");
        if (
            open &&
            (template_id || creation_id) &&
            org_id &&
            account?.account_id &&
            !mutationRender.isLoading &&
            !post?.image_url
        ) {
            const payload = {
                type: template_id ? "template" : "creation",
                template_id: template_id,
                width: 1080,
                height: 1080,
                output_format: "jpeg",
                queryString: `${queryfy(prefill)}&qi_organization=${org_id}`,
            };
            log.d(payload, "SPB Payload");
            mutationRender.mutate(payload);
        }
    }, [template_id, creation_id, org_id, open]);

    const postOnInsta = () => {
        log.d(post, "SPB Now posting on instagram with");
        if (post?.caption && post?.image_url) {
            const payload = {
                caption: post?.caption,
                image_url: post?.image_url,
                account_id: account?.account_id,
            };
            log.d(payload, "Now posting on instagram with");
            mutationPostInstagram.mutate(payload);
        }
    };

    if (!org_id) {
        return <></>;
    }

    return (
        <>
            {successSK && filteredAccounts?.length === 0 && (
                <Button
                    icon={<PlusOutlined />}
                    onClick={() => {
                        history.push("/settings/social-accounts");
                    }}
                >
                    Connect {platformKey || "Accounts"}
                </Button>
            )}
            {successSK && filteredAccounts?.length > 0 && (
                <Dropdown.Button
                    menu={{
                        items: filteredAccounts.map((item) =>
                            getMenuItem(item)
                        ),
                        selectable: true,
                        defaultActiveFirst: true,
                        onClick: ({ key }) =>
                            setAccount(
                                filteredAccounts.find(
                                    (i) => i.account_id === key
                                )
                            ),
                    }}
                    icon={<DownOutlined />}
                    onClick={() => {
                        setOpen(true);
                    }}
                    style={{
                        width: "auto",
                    }}
                    // choose class based on requested platform if any, otherwise account
                    className={
                        PLATFOMR_CLASS_MAPPING[platformKey] ||
                        PLATFOMR_CLASS_MAPPING[account?.platform]
                    }
                    type="ghost"
                >
                    {(platformKey && PLATFORM_ICON_MAPPING[platformKey]) ||
                        (account?.platform &&
                            PLATFORM_ICON_MAPPING[account?.platform])}
                    {account?.profile_info?.name
                        ? `Post on ${account?.profile_info?.name}`
                        : platformKey
                        ? `Post on ${platformKey}`
                        : "Select Account"}
                </Dropdown.Button>
            )}
            <Modal
                open={open}
                onCancel={() => setOpen(false)}
                title={
                    platformKey === "Linkedin"
                        ? "Post on LinkedIn"
                        : "Post on Instagram"
                }
                icon={
                    platformKey === "Linkedin" ? (
                        <LinkedinOutlined />
                    ) : (
                        <InstagramOutlined />
                    )
                }
                okText="Post Now"
                onOk={postOnInsta}
                okButtonProps={{
                    loading: mutationPostInstagram.isLoading,
                }}
                width={548}
            >
                {/* <pre>{JSON.stringify(post, null, 2)}</pre> */}
                <Form layout="vertical" style={{ width: "500px" }}>
                    <Form.Item label="Caption">
                        <Input.TextArea
                            placeholder="Caption"
                            rows={3}
                            value={post?.caption}
                            onChange={(e) =>
                                setPost({ ...post, caption: e.target.value })
                            }
                        />
                        <Button
                            onClick={() => {
                                if (post?.image_url && org_id) {
                                    mutationCaption.mutate({
                                        img_url: post?.image_url,
                                        org_id: org_id,
                                    });
                                }
                            }}
                            disabled={!post?.image_url}
                            loading={mutationCaption.isLoading}
                        >
                            Write with AI
                        </Button>
                    </Form.Item>
                    <Form.Item label="Media">
                        {mutationRender.isLoading && (
                            <Skeleton.Image
                                active={true}
                                style={{ width: "500px", height: "500px" }}
                            />
                        )}
                        {post?.image_url && (
                            <img
                                src={post?.image_url}
                                style={{
                                    width: "100%",
                                    // height: "500px",
                                    objectFit: "contain",
                                    borderRadius: "8px",
                                }}
                            />
                        )}
                    </Form.Item>
                </Form>
            </Modal>
            {contextHolder}
        </>
    );
}

export default SocialPostButton;

function getMenuItem(item) {
    switch (item?.platform) {
        case "Instagram":
            return {
                key: item.account_id,
                label: item?.profile_info?.name || "Instagram User",
                icon: <InstagramOutlined />,
            };
        case "Linkedin":
            return {
                key: item.account_id,
                label: item?.profile_info?.name || "LinkedIn User",
                icon: <LinkedinOutlined />,
            };
    }
}

const PLATFORM_ICON_MAPPING = {
    Instagram: <InstagramFilled />,
    Linkedin: <LinkedinFilled />,
    Facebook: <FacebookFilled />,
};

const PLATFOMR_CLASS_MAPPING = {
    Instagram: "q_social_instagram_btn",
    Linkedin: "q_social_linkedin_btn",
    Facebook: "q_social_facebook_btn",
};

function queryfy(obj) {
    const buildQuery = (prefix, obj) => {
        return Object.keys(obj)
            .map((key) => {
                const value = obj[key];
                const prefixedKey = prefix ? `${prefix}.${key}` : key;
                if (typeof value === "object" && value !== null) {
                    return buildQuery(prefixedKey, value);
                } else {
                    return `${prefixedKey}=${value}`;
                }
            })
            .join("&");
    };
    return buildQuery("", obj);
}
